import { all, put, takeEvery, take } from 'redux-saga/effects';

import { CLOSE_ALL_COLLAPSIBLE, AFTER_CLOSE_COLLAPSIBLE } from 'constants/actionTypes';
import { removeAllCollapsible } from 'actions/modalActions';

export default function* collapsibleModalSaga() {
    yield all([
        takeEvery(CLOSE_ALL_COLLAPSIBLE, function* () {
            yield take(AFTER_CLOSE_COLLAPSIBLE);
            yield put(removeAllCollapsible());
        })
    ]);
}
